/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createExpm1 } from '../../factoriesAny.js';
export var expm1Dependencies = {
  ComplexDependencies: ComplexDependencies,
  typedDependencies: typedDependencies,
  createExpm1: createExpm1
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesExpm1.generated.js
// module id = 1404
// module chunks = 0